export default "__VITE_ASSET__C_wK1A15__"